import { render } from "./DetentionStatusPill.vue?vue&type=template&id=cdd224d2&scoped=true"
import script from "./DetentionStatusPill.vue?vue&type=script&lang=js"
export * from "./DetentionStatusPill.vue?vue&type=script&lang=js"

import "./DetentionStatusPill.vue?vue&type=style&index=0&id=cdd224d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd224d2"]])

export default __exports__